import React from 'react';

/*
 * SearchInput — Standalone search bar (shared)
 *
 * Location: components/shared/SearchInput.js
 *
 * Reusable search input that can be used:
 *   - Inside FilterTemplate (replaces HeaderComponent's search)
 *   - Inside FilteredPayments (standalone)
 *   - Anywhere a search bar is needed
 *
 * Usage:
 *   <SearchInput
 *     value={searchQuery}
 *     onChange={setSearchQuery}
 *     placeholder="Search by name, date..."
 *   />
 *
 * Props:
 *   value       – current search string
 *   onChange     – callback with new value
 *   placeholder  – placeholder text (default: 'Search...')
 */

const SearchInput = ({
  value = '',
  onChange,
  placeholder = 'Search...',
}) => {
  return (
    <div className="fr-search-bar">
      <span className="fr-search-icon">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </span>
      <input
        type="text"
        className="fr-search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
      {value && (
        <button
          className="fr-search-clear"
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default SearchInput;